import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/auth/AuthContext";

const Navbar = ({ data }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const { user, isAuthenticated, loading, logout } = useAuth();
    const navigate = useNavigate();

    const links = (
        data?.links || [
            { text: "Programs", url: "#programs" },
            { text: "Platform", url: "#platform" },
            { text: "Competitions", url: "#competitions" },
            { text: "Robotics", url: "#robots" },
            { text: "Partners", url: "#partnerships" },
            { text: "Research", url: "#research" },
            { text: "About", url: "#about" }
        ]
    ).map((item) => ({
        ...item,
        url: item.url?.startsWith("#")
            ? `/${item.url}`
            : item.url
    }));

    const getCtaUrl = () => {
        if (data?.ctaUrl?.startsWith("#")) {
            return `/${data.ctaUrl}`;
        }

        return data?.ctaUrl || "/#contact";
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const handleLogout = async () => {
        closeMenu();
        await logout();
    };

    useEffect(() => {
        console.log("Authentication state:", {
            isAuthenticated,
        });
    }, [isAuthenticated]);

    return (
        <header className="site-header">
            <div className="container">
                <nav className="navbar">

                    {/* Logo */}
                    <Link
                        to="/"
                        className="nav-logo"
                        onClick={closeMenu}
                    >
                        {data?.logo ? (
                            <img
                                src={data.logo}
                                alt={data.logoAlt || "STEMX365"}
                            />
                        ) : (
                            <span>STEMX365</span>
                        )}
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="nav-links">
                        {links.map((item, index) => (
                            <Link
                                key={index}
                                to={item.url}
                                onClick={closeMenu}
                            >
                                {item.text}
                            </Link>
                        ))}
                    </div>

                    {/* Desktop Actions */}
                    <div className="nav-actions">

                        {data?.ctaText && (
                            <Link
                                to={getCtaUrl()}
                                className="nav-cta"
                                onClick={closeMenu}
                            >
                                {data.ctaText}
                            </Link>
                        )}
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        type="button"
                        className={`nav-toggle ${menuOpen ? "active" : ""
                            }`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label={
                            menuOpen
                                ? "Close navigation menu"
                                : "Open navigation menu"
                        }
                        aria-expanded={menuOpen}
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </nav>

                {/* Mobile Navigation */}
                <div
                    className={`mobile-nav ${menuOpen ? "open" : ""
                        }`}
                >
                    <div className="mobile-nav-links">

                        {links.map((item, index) => (
                            <Link
                                key={index}
                                to={item.url}
                                onClick={closeMenu}
                            >
                                {item.text}
                            </Link>
                        ))}

                        {data?.ctaText && (
                            <Link
                                to={getCtaUrl()}
                                className="mobile-cta"
                                onClick={closeMenu}
                            >
                                {data.ctaText}
                            </Link>
                        )}

                  
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Navbar;